// middleware/result.ts
import { useResultStore } from '~/store/result'
// import { getResultsParamsState } from '~/composables/useResultsParams'
import { getParams } from '~/utils/validateQueryParams'

const normalize = (p: string) => p.replace(/\/+$/, '') || '/'

const normalizeQuery = (q: any) => {
	const out: Record<string, string> = {}
	Object.keys(q || {})
		.sort()
		.forEach((k) => {
			const v = q[k]
			if (v === undefined || v === null) return
			out[k] = Array.isArray(v) ? String(v[0]) : String(v)
		})
	return out
}

export default defineNuxtRouteMiddleware((to) => {
	const nuxtApp = useNuxtApp()
	const resultStore = useResultStore()
	const resultsParams = getResultsParamsState(to.query)

	resultStore.SET_STATE_RESULT({ type: 'lottery', value: resultsParams.lottery })
	resultStore.SET_STATE_RESULT({ type: 'country', value: resultsParams.country })
	resultStore.SET_STATE_RESULT({ type: 'numbers', value: resultsParams.numbers })
	resultStore.SET_STATE_RESULT({ type: 'current_numbers', value: resultsParams.numbers })
	resultStore.SET_STATE_RESULT({ type: 'isMutipleBets', value: resultsParams.isMultipleBets })
	resultStore.SET_STATE_RESULT({ type: 'amount', value: resultsParams.amount })

	if (!resultsParams.hasSufficientParams) {
		resultStore.SET_STATE_RESULT({ type: 'lotteries', value: null })
		resultStore.SET_STATE_RESULT({ type: 'analytics', value: null })
		resultStore.SET_STATE_RESULT({ type: 'pagination', value: null })
		resultStore.SET_STATE_RESULT({ type: 'prizes', value: null })
		resultStore.SET_STATE_RESULT({ type: 'lottery_id', value: null })
	}

	if (import.meta.client) {
		const user = JSON.parse(localStorage.getItem('user') ?? 'null')
		resultStore.SET_STATE_RESULT({ type: 'user', value: user })
	}

	const { $i18n } = nuxtApp
	const currentLocale = $i18n.locale.value
	const localePath = useLocalePath()
	const getLocalizedPath = (path: string) => localePath(path, currentLocale)

	const current = normalize(to.path)
	const localizedCurrent = getLocalizedPath(current)

	if (!resultsParams.hasSufficientParams) return
	if (!resultsParams.lottery || !resultsParams.country) return

	// ✅ Usa resultsParams (fresco de la query) en vez del store
	const params = getParams({
		country: resultsParams.country,
		lottery: resultsParams.lottery,
		numbers: resultsParams.numbers,
		isMutipleBets: resultsParams.isMultipleBets,
		amount: resultsParams.amount,
	})

	const samePath = normalize(localizedCurrent) === normalize(current)
	const sameQuery = JSON.stringify(normalizeQuery(to.query)) === JSON.stringify(normalizeQuery(params))

	if (samePath && sameQuery) return

	return params ? navigateTo({ path: localizedCurrent, query: params }) : navigateTo(localizedCurrent)
})
